import request from './request';

// 获取指定用户的操作日志
export function getLogsByUsername(username) {
  return request({
    url: `/api/operation/logs/user/${username}`,
    method: 'get'
  });
}

// 获取指定用户的最新操作日志
export function getLatestLogsByUsername(username) {
  return request({
    url: `/api/operation/logs/user/${username}/latest`,
    method: 'get'
  });
}

// 获取所有操作日志，按时间倒序排列
export function getAllLogs() {
  return request({
    url: '/api/operation/logs/all',
    method: 'get'
  });
}